/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import PageBox from "../../layouts/pageBox";
import {useForm, Controller } from "react-hook-form";
import {ReactComponent as Email} from "../../assets/img/forms/email.svg";
import {ReactComponent as Eye} from "../../assets/img/forms/eye.svg";
import {ReactComponent as CheckboxEmpty} from "../../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../../assets/img/forms/checkbox-full.svg";
import {ReactComponent as ArrowRight} from "../../assets/img/icons/arrow-right-white.svg";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useAuth} from "../../Hooks/useAuth";

const DashBoard = () => {

    const axiosJWT = useAxiosJTW();
    const user = useAuth();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [showPass, setShowPass] = useState(false);
    const [confirmPass, setConfirmPass] = useState(false);
    const [requestStatus, setRequestStatus] = useState(false);

    function toogleShow(){
        setShowPass(v => !v);
    }

    const { control, register, handleSubmit, watch, reset, setError, formState: { errors }, trigger, clearErrors } = useForm({
        mode: "onChange",
        defaultValues: {
            fname: user.profile.fname,
            lname: user.profile.lname,
            phone: user.profile.phone,
            email: user.profile.email,
            user_id : user.profile.user_id,
            group_id: user.profile.group_id,
            password: '',
            confirmPassword: ''
        }
    });

    const userRegister = (data) => {

        setConfirmPass(false);
        setRequestStatus(false);

        let _pass = '';
        if ( data.password.trim() !== '' ){
            if( ( data.password === data.confirmPassword) ){
                _pass = data.password;
            }else{
                setConfirmPass(true);
            }
        }

        const dataToSend = {
            fname: data.fname,
            lname: data.lname,
            phone: data.phone,
            email: data.email,
            user_id : data.user_id,
            group_id: data.group_id,
            password: _pass,
        }
        setRequestStatus(true);
        console.log(dataToSend);
        return;

        axiosJWT.post('api/register', {user}).then( (response) => {

            setRequestStatus(true);
        } ).catch((error) => {
            console.log(error);
        });
    }

    const onSubmit = data => {
        userRegister(data);
    };

    return (
        <PageBox small={true} smallbox={true}>
            <div className='page-body'>
                <div className='dashBoard pt-md-4 pb-md-4'>
                    <div className='dashBoard__title'>{t('login.yourProfile')}</div>
                    <form className='login-form' onSubmit={handleSubmit(onSubmit)}>

                        <input type='hidden' {...register("user_id",{required: `${t('fields.requiredfield')}`} )}/>
                        <input type='hidden' {...register("group_id",{required: `${t('fields.requiredfield')}`} )}/>

                        <div className="form-group">
                            <label htmlFor='loginEmail'>{t('fields.fname')}</label>
                            <div className='form-group__wrap'>
                                <input id='loginEmail' className="form-control" type="text" {...register("fname",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.fnamePlace')}/>
                            </div>
                            { errors.fname && <small className="text-danger">{errors.fname?.message}</small>}
                        </div>

                        <div className="form-group">
                            <label htmlFor='loginEmail'>{t('fields.lname')}</label>
                            <div className='form-group__wrap'>
                                <input id='loginEmail' className="form-control" type="text" {...register("lname",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.lnamePlace')}/>
                            </div>
                            { errors.lname && <small className="text-danger">{errors.lname?.message}</small>}
                        </div>

                        <div className="form-group">
                            <label htmlFor='loginEmail'>{t('fields.phone')}</label>
                            <div className='form-group__wrap'>
                                <input id='loginEmail' className="form-control" type="text" {...register("phone",{
                                    minLength: {
                                        value: 10,
                                        message: 'At least 10 digits'
                                    },
                                } )} placeholder={t('fields.phonePlace')}/>
                            </div>
                            { errors.phone && <small className="text-danger">{errors.phone?.message}</small>}
                        </div>

                        <div className="form-group">
                            <label htmlFor='loginEmail'>{t('fields.email')}</label>
                            <div className='form-group__wrap'>
                                <input id='loginEmail' className="form-control" type="email" {...register("email",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.emailPlace')}/>
                                <span className='form-group__icon'><Email/></span>
                            </div>
                            { errors.email && <small className="text-danger">{errors.email?.message}</small>}
                        </div>

                        <div className="form-group">
                            <label htmlFor='loginPassword'>{t('fields.password')}</label>
                            <div className='form-group__wrap'>
                                <input id='loginPassword' className="form-control" type={showPass ? "text" : "password"} {...register("password" )} placeholder={t('fields.passPlace')}/>
                                <span className='form-group__icon form-group__icon--password' onClick={toogleShow}>
                                        {!showPass
                                            ? <span className='icon--opened'><Eye/></span>
                                            : <span className='icon--closed'><Eye/></span>
                                        }
                                </span>
                            </div>
                            { errors.password && <small className="text-danger">{errors.password?.message}</small>}
                        </div>

                        <div className="form-group">
                            <label htmlFor='loginPassword'>{t('fields.confirmpassword')}</label>
                            <div className='form-group__wrap'>
                                <input id='loginPassword' className="form-control" type={showPass ? "text" : "password"} {...register("confirmPassword" )} placeholder={t('fields.confirmpassword')}/>
                                <span className='form-group__icon form-group__icon--password' onClick={toogleShow}>
                                        {!showPass
                                            ? <span className='icon--opened'><Eye/></span>
                                            : <span className='icon--closed'><Eye/></span>
                                        }
                                </span>
                            </div>
                            { errors.confirmPassword && <small className="text-danger">{errors.confirmPassword?.message}</small>}
                        </div>



                        {/*<div className="form-group mb-4">*/}
                        {/*    <label className="custom-checkbox">*/}
                        {/*        <input*/}
                        {/*            type="checkbox"*/}
                        {/*            value="1"*/}
                        {/*            {...register("terms", {required: 'Required Field'} )}*/}
                        {/*        />*/}
                        {/*        <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>*/}
                        {/*        <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>*/}
                        {/*        Accept terms and conditions.*/}
                        {/*    </label>*/}
                        {/*    { errors.terms && <small className="form-error text-danger">{errors.terms?.message}</small>}*/}
                        {/*</div>*/}
                        {confirmPass && <div className="alert alert-danger" role="alert">
                            {t('fields.Passwordsnotmatch')}
                        </div>}

                        <div className='pt-4'>
                            <button type="submit" className='btn btn-primary btn-block'>{t('fields.UpdateProfile')}</button>
                        </div>

                        {requestStatus && <div className='pt-4'><div className="alert alert-success" role="alert">
                            {t('fields.profileupdated')}
                        </div></div>}

                    </form>
                </div>
            </div>
        </PageBox>
    );
};

export default DashBoard;